import { render, staticRenderFns } from "./delivery-unit-service.vue?vue&type=template&id=692b1836&"
import script from "./delivery-unit-service.vue?vue&type=script&lang=js&"
export * from "./delivery-unit-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports